/**************************************************
 * Nombre:       Tarjeta_Detalle_Especificaciones
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {useState} from "react";
import Tarjeta_Espeficacion from "./Tarjeta_Espeficacion";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";

const Tarjeta_Detalle_Especificaciones = ({item}) => {
    const {sCell, masSM} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'center'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container size={{xs: 2, sm: 2, md: 2}} sx={{justifyContent: 'center'}}>
                <img src={item.img} width={item.largo} height={'auto'}/>
            </Grid>

            <Grid container size={{xs: 10, sm: 10, md: 10}} sx={{justifyContent: 'flex-start'}}>
                <Typography sx={{fontWeight: 800, fontSize: !masSM ? 20 : 24, lineHeight: 1.1}}>{item.nombre}</Typography>
            </Grid>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{mt: 2}}
            >

                {item.items.map((it, index) => (
                    <Tarjeta_Espeficacion it={it} index={index}/>
                ))}

            </Grid>

        </Grid>
    )

}
export default Tarjeta_Detalle_Especificaciones